import 'reflect-metadata';
import { Class, Transient } from 'constitute';
import Client from '@dealroadshow/socket-frontend-sdk';
import SocketDispatcherProvider from '@/dmPortal/application/DI/Rpc/SocketDispatcher';

export default new Class(Client, Transient.with([SocketDispatcherProvider]));
